<template>
  <article>
    <p class="has-text-weight-light mb-1">
      Define documents that must be uploaded against assets of this type. Any asset missing one of
      these appears on the daily missing-documents report. Adding at least one makes documents required for this type.
    </p>

    <div
      class="grid has-6-columns gap-1 align-center mb-1"
      v-for="requiredDocument in requiredDocuments"
      :key="requiredDocument._key">
      <text-input
        class="is-3-columns"
        placeholder="e.g. License disc"
        :value="requiredDocument.description"
        @input="value => updateRequiredDocumentDescription({ key: requiredDocument._key, value })">
        Description
      </text-input>

      <switch-input
        class="is-2-columns"
        classes="is-large"
        description="Force an expiry date when this document is uploaded."
        :value="requiredDocument.has_expiry"
        @input="toggleRequiredDocumentExpiry(requiredDocument._key)">
        Has expiry date
      </switch-input>

      <a class="delete is-medium" @click="removeRequiredDocument(requiredDocument._key)"></a>
    </div>

    <notification class="is-cool-blue has-text-centered p-2 is-marginless" v-if="!requiredDocuments.length">
      <p class="has-text-weight-bold">No Required Documents</p>
      <p>This asset type has no required documents.</p>
    </notification>

    <action-button class="is-rounded mt-1" left-icon="plus" @click="addRequiredDocument">
      Add Required Document
    </action-button>
  </article>
</template>

<script>
import { mapMutations, mapState } from 'vuex'

export default {
  computed: {
    ...mapState('assetType', ['assetType']),
    requiredDocuments() {
      return this.assetType.required_documents || []
    },
  },

  methods: {
    ...mapMutations('assetType', [
      'addRequiredDocument',
      'updateRequiredDocumentDescription',
      'toggleRequiredDocumentExpiry',
      'removeRequiredDocument',
    ]),
  },
}
</script>
